<template>
  <div :class="[ask.no?'cloze borTop':'cloze']">
    <div :class="{'padding':Number(number)||Number(number)===0}">
      <p class="askTitle" v-html="ask.question_title" v-if="ask.question_title"></p>
      <!-- 小题题干 -->
      <p :class="[myColor?'inspect_myColor':'article']" v-html="$options.filters.strReplace(ask.content,'\#\#','或')" v-if="ask.content"></p>
      <!-- 小题题干图片 -->
      <div class="cont_img" v-for="(img) in ask.image" v-if="ask.image">
        <img :src="img" alt=""/>
      </div>
      <span class="tit_num" v-if="Number(number)">{{number}}、</span>
      <span class="tit_num" v-else-if="Number(number)===0">{{ask.no}}、</span>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">

  export default {
    data() {
      return {}
    },
    //ask:小题数据
    props: ['ask', 'number','myColor'],
    components: {},
    methods: {},
    created() {
      
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

  .cloze {
    font-size: 30px/$ppr;
    color: #333;
    &.borTop {
      border-top: 1px/$ppr solid #E8E8E8;
    }
    p {
      padding: 32px/$ppr 24px/$ppr;
      border-top: 1px/$ppr solid #dcdcdc;
      &:first-child {
        border-top: none;
      }
    }
    .padding {
      position: relative;
      p:first-child {
        padding-left: 80px/$ppr;
      }
      .tit_num {
        position: absolute;
        top: 32px/$ppr;
        left: 24px/$ppr;
      }
    }
  }
</style>
